import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import type { Option } from 'modules/types'
import { useGetUsersFromImportRequests } from 'services/import-requests/hooks/useGetUsersFromImportRequests'

interface ImportRequestRequestedByFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const ImportRequestRequestedByFilter = ({ onApply, onReset }: ImportRequestRequestedByFilterProps) => {
  const usersQuery = useGetUsersFromImportRequests()

  const options =
    usersQuery.data?.data.map(user => ({
      label: user.email,
      value: user._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Requested by"
      loading={usersQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search by email"
    />
  )
}
